(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fm-catalog-request"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fm-catalog-request')) {
    customElements.define('fm-catalog-request', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.pendingEmail = '';
        this.enhanceFields = () => {
          const fields = {'name':'given-name','name-1':'family-name','email':'email','text':'address-line1','text-2':'address-line2','text-3':'address-level2','select':'address-level1','text-1':'postal-code'};
          Object.entries(fields).forEach(([id, autocomplete]) => {
            const field = this.querySelector('[id="169915-' + id + '"]');
            if (field) field.setAttribute('autocomplete', autocomplete);
          });
          const email = this.querySelector('input[id="169915-email"]');
          if (email) { email.type = 'email'; email.inputMode = 'email'; email.autocapitalize = 'off'; email.spellcheck = false; }
          const zip = this.querySelector('input[id="169915-text-1"]');
          if (zip) zip.inputMode = 'numeric';
          const address2 = this.querySelector('input[id="169915-text-2"]');
          const control = address2?.closest('.globo-form-control');
          if (control && !control.closest('.fm-address-details')) {
            const details = document.createElement('details');
            details.className = 'fm-address-details';
            details.open = Boolean(address2.value);
            const summary = document.createElement('summary');
            summary.textContent = this.dataset.fmAddress2Label;
            details.appendChild(summary);
            control.before(details);
            details.appendChild(control);
          }
        };
        this.enhanceFields();
        this.fieldObserver = new MutationObserver(this.enhanceFields);
        this.fieldObserver.observe(this, {childList:true,subtree:true});
        this.captureEmail = () => {
          const input = this.querySelector('input[id="169915-email"]');
          if (input && input.value) this.pendingEmail = input.value.trim();
        };
        this.addEventListener('input', this.captureEmail);
        this.addEventListener('change', this.captureEmail);
        this.addEventListener('submit', this.captureEmail, true);
        this.addEventListener('click', event => {
          if (event.target.closest('button[type="submit"], input[type="submit"]')) this.captureEmail();
          const link = event.target.closest('a.fm-catalog-email-cta');
          if (!link || !this.contains(link) || !this.catalogSucceeded) return;
          this.offerEmail();
          requestAnimationFrame(() => document.querySelector('[data-fm-newsletter-email]')?.focus({preventScroll:true}));
        });
        this.onCatalogSuccess = event => {
          if (String(event.detail?.formId) !== '169915') return;
          this.captureEmail();
          this.catalogSucceeded = true;
          this.classList.add('fm-catalog-request--complete');
          this.offerEmail();
        };
        document.addEventListener('fm:catalog-request-success', this.onCatalogSuccess);
      }
      offerEmail() {
        const signup = document.getElementById('fm-signup');
        if (signup && this.pendingEmail) signup.dispatchEvent(new CustomEvent('fm:newsletter-prefill', {detail:{email:this.pendingEmail,source:'catalog'}}));
      }
      disconnectedCallback() {
        document.removeEventListener('fm:catalog-request-success', this.onCatalogSuccess);
        this.fieldObserver?.disconnect();
        this.initialized = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fm-signup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fm-signup')) {
    document.addEventListener('click', event => {
      if (!event.target.closest('[data-fm-open-email]')) return;
      const signup = document.getElementById('fm-signup');
      if (signup && typeof signup.select === 'function') {
        signup.select('email');
        requestAnimationFrame(() => signup.querySelector('[data-fm-newsletter-email]')?.focus({preventScroll:true}));
      }
    });
    customElements.define('fm-signup', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const feedback = this.querySelector('.fm-signup__success, .fm-signup__error');
        if (feedback) feedback.focus();
        this.querySelectorAll('[data-fm-choice]').forEach(button => button.addEventListener('click', () => this.select(button.dataset.fmChoice)));
        this.addEventListener('fm:newsletter-prefill', event => {
          this.select('email');
          const input = this.querySelector('[data-fm-newsletter-email]');
          if (input && typeof event.detail?.email === 'string') input.value = event.detail.email;
          if (event.detail?.source === 'catalog') {
            const heading = this.querySelector('[data-fm-email-heading]');
            const submit = this.querySelector('[data-fm-after-catalog-button]');
            if (heading) heading.textContent = heading.dataset.fmAfterCatalogHeading;
            if (submit) submit.textContent = submit.dataset.fmAfterCatalogButton;
          }
        });
      }
      select(choice) {
        this.querySelectorAll('[data-fm-choice]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.fmChoice === choice)));
        this.querySelectorAll('[data-fm-panel]').forEach(panel => { panel.hidden = panel.dataset.fmPanel !== choice; });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
